import { StyleObject } from 'baseui';

export const containerStyles: StyleObject = {
	width: '100%',
	height: '100%',
	backgroundColor: '#f5f5f5'
};

export const filterContainerStyles: StyleObject = {
	height: '60px',
	display: 'flex',
	alignItems: 'center',
	backgroundColor: 'white',
	padding: '0 24px',
	borderBottom: '1px solid rgb(242, 242, 242)',
	justifyContent: 'space-between',
	width: '100%'
};

export const contentContainerStyles: StyleObject = {
	padding: '12px 24px'
};

export const cardStyles: StyleObject = {
	backgroundColor: 'white',
	padding: '24px',
	marginBottom: '20px',
	borderRadius: '8px',
	boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
	width: '100%'
};

export const cardHeaderStyles: StyleObject = {
	margin: '0 0 20px 0',
	fontSize: '18px',
	fontWeight: 600,
	color: '#1a1a1a',
	borderBottom: '2px solid #f0f0f0',
	paddingBottom: '12px'
};

export const listItemStyles: StyleObject = {
	padding: '12px',
	borderBottom: '1px solid #f2f2f2',
	display: 'flex',
	alignItems: 'center',
	transition: 'background-color 0.2s',
	':hover': {
		backgroundColor: '#f8f8f8'
	},
	borderRadius: '4px',
	fontSize: '14px'
};

export const matchTeamStyles: StyleObject = {
	fontWeight: 500,
	color: '#2d2d2d'
};

export const matchVsStyles: StyleObject = {
	margin: '0 12px',
	color: '#666',
	fontWeight: 500
};

export const drawItemStyles: StyleObject = {
	...listItemStyles,
	justifyContent: 'space-between'
};

export const drawNumberStyles: StyleObject = {
	fontWeight: 500,
	color: '#2d2d2d',
	backgroundColor: '#f0f0f0',
	padding: '4px 8px',
	borderRadius: '4px'
};

export const winningNumberStyles: StyleObject = {
	color: '#444',
	fontFamily: 'monospace',
	fontSize: '14px'
};

export const rewardStyles: StyleObject = {
	color: '#2d9d3f',
	fontWeight: 600
};

// DateRangeFilter styles
export const dateRangeFormStyles: StyleObject = {
	display: 'flex',
	gap: '30px'
};

export const datePickerContainerStyles: StyleObject = {
	width: '350px'
};

export const noDataContainerStyles: StyleObject = {
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
	justifyContent: 'center',
	padding: '40px',
	backgroundColor: 'white',
	borderRadius: '8px',
	boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
	margin: '20px 0'
};

export const noDataTextStyles: StyleObject = {
	fontSize: '16px',
	color: '#666',
	marginTop: '12px'
};
